import { immerable } from 'immer';

import { IResolution } from 'api/types';

/* -------------------------------------------------------------------------------------------------
 * ICameraImageModel
 * -----------------------------------------------------------------------------------------------*/
export interface ICameraImageModel {
    _id: string;
    name: string;
    date: string;
    time: string;
    datetime: string;
    takenAt: string;
    resolution: IResolution;
    urlThumb: string;
    urlPreview: string;
    url4k: string;
    score?: string;
}

/* -------------------------------------------------------------------------------------------------
 * CameraImageModel
 * -----------------------------------------------------------------------------------------------*/
export class CameraImageModel {
    [immerable] = true;

    _id: string;
    name: string;
    date: string;
    time: string;
    datetime: string;
    takenAt: string;
    resolution: IResolution;
    urlThumb: string;
    urlPreview: string;
    url4k: string;
    score?: string;

    constructor(data: Partial<ICameraImageModel>) {
        this._id = data._id ?? '';
        this.name = data.name ?? '';
        this.date = data.date ?? '';
        this.time = data.time ?? '';
        this.datetime = data.datetime ?? '';
        this.takenAt = data.takenAt ?? '';
        this.resolution = data.resolution ?? null;
        this.urlThumb = data.urlThumb ?? '';
        this.urlPreview = data.urlPreview ?? '';
        this.url4k = data.url4k ?? '';
        this.score = data.score ?? '';
    }

    static fromObject(data: Partial<ICameraImageModel>): CameraImageModel {
        const model = new CameraImageModel(data);

        return model;
    }

    static fromObjectList(data: Partial<ICameraImageModel>[]): CameraImageModel[] {
        return data.map((row) => CameraImageModel.fromObject(row));
    }

    toObject(): ICameraImageModel {
        const data: Partial<ICameraImageModel> = {
            _id: this._id,
            name: this.name,
            date: this.date,
            time: this.time,
            datetime: this.datetime,
            takenAt: this.takenAt,
            resolution: this.resolution,
            urlThumb: this.urlThumb,
            urlPreview: this.urlPreview,
            url4k: this.url4k,
            score: this.score,
        };

        return data as ICameraImageModel;
    }
}
